import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Error500Component } from "./pages/error500/error500.component";
import { Error404Component } from "./pages/error404/error404.component";
import { AuthGuard } from "src/app/authentication/auth.guard";
import { LanguageGuard } from "./authentication/language.guard";
import { VCESCallbackComponent } from "./pages/vces-callback/vces-callback.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [AuthGuard], // visit home only if authenticated
  },
  {
    path: "offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "zambia",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "zambia/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "zambia/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "zambia/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "namibia",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "namibia/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "namibia/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "namibia/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ssa",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ssa/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ssa/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ssa/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ghana",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ghana/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ghana/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ghana/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ivorycoast",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ivorycoast/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ivorycoast/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "ivorycoast/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "accessbank",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "accessbank/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "accessbank/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "accessbank/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "cameroon",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "cameroon/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "cameroon/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "cameroon/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "senegal",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "senegal/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "senegal/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "senegal/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "absa",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "absa/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "absa/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "absa/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "visazimsmereward",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "visazimsmereward/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "visazimsmereward/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "visazimsmereward/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "mywelcomepickups",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "mywelcomepickups/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "mywelcomepickups/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "mywelcomepickups/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "benin",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "benin/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "benin/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "benin/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "drc",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "drc/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "drc/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "drc/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "guinea",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "guinea/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "guinea/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "guinea/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "capeverde",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "capeverde/offers/:category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "capeverde/offers/:category/:sub_category",
    loadChildren: () =>
      import("./pages/homepage/homepage.module").then((m) => m.HomepageModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "capeverde/offer",
    loadChildren: () =>
      import("./pages/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "redemption-history",
    loadChildren: () =>
      import("./pages/redemption/redemption.module").then(
        (m) => m.RedemptionModule
      ),
    canActivate: [LanguageGuard],
  },
  { path: "error", component: Error500Component },
  {
    path: "info",
    loadChildren: () => import("./info/info.module").then((m) => m.InfoModule),
    canActivate: [LanguageGuard],
  },
  {
    path: "confirm-email/:code",
    loadChildren: () =>
      import("./pages/email-confirmation/email-confirmation.module").then(
        (m) => m.EmailConfirmationModule
      ),
    canActivate: [LanguageGuard],
  },
  { path: "vces_callback", component: VCESCallbackComponent },
  { path: "**", pathMatch: "full", component: Error404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
